import * as Constants from '../constants/';

const initialState = {
  currentStep: 0,
  steps: new Map(
    Constants.WALKTHROUGH_STEP_SEQUENCE.map((key, idx) => {
      return [
        key,
        {
          key: key,
          stepNum: idx + 1,
          isOpen: false,
          isLast: Boolean(
            idx + 1 === Constants.WALKTHROUGH_STEP_SEQUENCE.length
          )
        }
      ];
    })
  ),
  numSteps: Constants.WALKTHROUGH_STEP_SEQUENCE.length
};

export default function(state = initialState, action) {
  let nextStep;
  let newSteps;
  switch (action.type) {
    case Constants.START_WALKTHROUGH:
      nextStep = 1;
      newSteps = new Map();
      state.steps.forEach((step, k) => {
        newSteps.set(step.key, {
          ...step,
          isOpen: step.stepNum === nextStep
        });
      });
      return {
        ...state,
        steps: newSteps,
        currentStep: nextStep
      };
    case Constants.INCREMENT_WALKTHROUGH_STEP:
      nextStep = state.currentStep + 1;
      newSteps = new Map();
      state.steps.forEach((step, k) => {
        newSteps.set(step.key, {
          ...step,
          isOpen: step.stepNum === nextStep
        });
      });
      return {
        ...state,
        steps: newSteps,
        currentStep: nextStep
      };
    case Constants.CLOSE_WALKTHROUGH:
      nextStep = -1;
      const newStepsToClose = new Map();
      state.steps.forEach((step, k) => {
        newStepsToClose.set(step.key, {
          ...step,
          isOpen: false
        });
      });
      return {
        ...state,
        steps: newStepsToClose,
        currentStep: nextStep
      };
    default:
      return state;
  }
}
